import Interceptors from './Interceptors/Interceptors';
import Options from './Utils/Options';
import Loader from './Loaders/Loader';
import Emitter from './Utils/Emitter';
import Logger from './Utils/Logger';
/**
 * @class
 * @description Core class for the p2p plugin. It includes the options, the websocket communication,
 * @exports CdnBalancer
 */
export default class CdnBalancer extends Emitter {
    /**
     * Constructs CdnBalancer.
     * @param {constructionOptions} constructionOptions JSON with the options to construct the balancer.
     */
    constructor(constructionOptions) {
        super();
        this.options = new Options(constructionOptions);
        this._loader = new Loader(this.options);
        this.interceptors = new Interceptors(this);
        var cdnBalancer = this;
        /*console.log("[NPAW] Register fetch interceptor");
    
        const unregister = fetchIntercept.register({
          request: function (url, config) {
           
            let urlTest = url;
            urlTest = urlTest.split('?')[0];
      
            
      
            if( urlTest.endsWith(".m3u8") || urlTest.endsWith(".ts")  ){
                let urlObject = new URL(urlTest);
                const newUrl = cdnBalancer.getCdnLoader().simpleRequest(urlObject);
                return [newUrl.toString(), config];
            }
    
            return [url, config];
          },
    
        
         /* requestError: function (error) {
            return Promise.reject(error);
          },*/
        /* response: function (response) {
           const clonedResponse = response.clone();
           const json = () =>
             clonedResponse
               .json()
               .then((data) => ({ ...data, title: `Intercepted: ${data.title}` }));
       
           response.json = json;
           return response;
         },
       
         responseError: function (error) {
           return Promise.reject(error);
         },*/
        // });
        /*xhrPrototype.setRequestHeader = function(header, value) {
         if (!intercepted && headersLog) {
             headersLog[header] = value;
         }
     
         return proxied.setRequestHeader.apply(this, arguments);
     }   ;*/
        var open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
            let urlTest = url;
            let originalUrl = url;
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
            //      if( !url.includes("&rnpaw=") && !url.includes("?rnpaw=") )
            if (method === "GET" && (urlTest.endsWith(".mpd") || urlTest.endsWith(".mp4") || urlTest.endsWith(".m3u8") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s"))) {
                Logger.log("XHR-intercepted -> " + url);
                let params;
                if (splitted.length > 1)
                    params = splitted[1];
                url = urlTest;
                let urlObject = new URL(url);
                let newUrl = "";
                try {
                    newUrl = cdnBalancer.simpleRequest(urlObject);
                    newUrl = newUrl.trim();
                }
                catch (error) { }
                if (newUrl === "") {
                    newUrl = originalUrl;
                }
                else {
                    if (params) {
                        if (newUrl.includes("?")) {
                            newUrl = newUrl + "&" + params;
                        }
                        else {
                            newUrl = newUrl + "?" + params;
                        }
                    }
                }
                this.addEventListener('load', function (e) {
                });
                this.addEventListener('loadstart', function (e) {
                    cdnBalancer.getLoader().loadStartEM(this, urlObject, e);
                });
                this.addEventListener('readystatechange', function () {
                    let isOk = cdnBalancer.getLoader().readyStateChangeEM(this, urlObject);
                    if (isOk === false) {
                        cdnBalancer.openAndSend(this, url);
                    }
                });
                this.addEventListener('progress', function (e) {
                    cdnBalancer.getLoader().progressEM(this, urlObject, e);
                });
                this.addEventListener('loadend', function (e) {
                    cdnBalancer.getLoader().loadEndEM(this, urlObject, e);
                });
                this.addEventListener('error', function (e) {
                });
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return open.call(this, method, newUrl, ...rest);
            }
            else {
                // let urlObject = new URL(url); 
                // let urlPath = urlObject.pathname;
                Logger.log("XHR-not-intercepted -> " + url);
                //let newUrl = "https://sb-eu-1.npaw.com/test/"+urlPath+"?orresource="+url;
                //newUrl = newUrl.replace("//","/");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return open.call(this, method, url, ...rest);
            }
        };
    }
    openAndSend(request, url) {
        try {
            request.open("GET", url);
            request.send();
        }
        catch (error) {
        }
    }
    /**
     * Redirects adapter's requests to loader.
     * If loader is not ready yet it retries again after 200ms.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer set as true if is expected to get the manifest response in ArrayBuffer format.
     * @public
     */
    request(url, download, callbacks, headers, retries, forceArrayBuffer, stats) {
        this._loader.processSegment(url, true, callbacks, headers, retries, forceArrayBuffer, stats);
    }
    /**
     * Sets the manifest URL of the played content to the options object.
     * For url changes the loader is restarted.
     * @param {string} url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        if (url && this.options.resource !== url) {
            this.options.resource = url;
            this._loader = new Loader(this.options);
            this._loader.loadCDNBalancerData();
        }
    }
    getLoader() {
        return this._loader;
    }
    addInterceptor(name, player) {
        this.interceptors.loadInterceptor(name, player);
    }
    simpleRequest(url) {
        Logger.log("Balancing " + url.toString());
        if ((this.options.resource == undefined || this.options.resource === '')) {
            this.setManifestResource(url.toString());
        }
        let segment = this._loader.processSegment(url, false, []);
        // Adding segment to segments maps
        let override = (this.options.overrideManifest && segment.isManifest);
        if (!segment.isManifest)
            override = true;
        let newUrl = override ? segment.finalUrl : segment.url;
        this._loader.segmentsMap.set(newUrl, url.toString());
        return newUrl;
    }
}
